import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';

import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
// import { environment } from '../../../environments/environment';
import {
  ApplicationState, GetAddressByDbLink, getApplicationState, getAppSettings, GetPrintSvcConn, getPropertiesState, GetPropertyBoundingBox,
  PropertiesState, State
} from 'src/app/state-management';

@Component({
    selector: 'app-service-connection',
    templateUrl: './service-connection.component.html',
    styleUrls: ['./service-connection.component.scss'],
    standalone: false
})
export class ServiceConnectionComponent implements OnInit, AfterViewInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject();
  propertiesState$: Observable<PropertiesState>;
  propertiesState: PropertiesState;
  appSettings$: Observable<any>;
  applicationState$: Observable<ApplicationState>;
  dblink: string;
  windowWidth: number;

  sanitary: any;
  storm: any;
  water: any;


  buildingBaseMap = '';
  orthoBasemap = '';
  parcels = '';
  rightOfWay = '';
  serviceConnections = '';

  boundingBox: any;
  today: number = Date.now();
  opacity: number;
  token: string;

  constructor(
    private store: Store<State>,
    private route: ActivatedRoute
  ) {
    this.propertiesState$ = this.store.select(getPropertiesState);
    this.appSettings$ = this.store.select(getAppSettings);
    this.applicationState$ = this.store.select(getApplicationState);
  }

  ngOnInit(): void {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('service-report');
    const dblink = 'dblink';
    const token = 'token';
    if (this.route.snapshot && this.route.snapshot.queryParams) {
      this.dblink = this.route.snapshot.queryParams[dblink];
      this.token = this.route.snapshot.queryParams[token];
      if (this.dblink && this.dblink.length > 0) {
        this.store.dispatch(new GetPrintSvcConn(this.dblink));
        this.store.dispatch(new GetPropertyBoundingBox(this.dblink));
        this.store.dispatch(new GetAddressByDbLink(this.dblink));
        this.getBoundingBox();
      }
      this.opacity = this.route.snapshot.queryParams['opacity'] ? this.route.snapshot.queryParams['opacity'] : 0;
    }

    this.applicationState$.pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe((state: ApplicationState) => {
      this.windowWidth = state.windowInnerWidth - 14;  // 14 = padding
      if (state.windowInnerWidth > 980) {
        this.windowWidth = 980;
      }
    });

  }

  ngAfterViewInit(): void {

  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  print(): void {
    window.print();
  }

  isNullOrEmpty(val: any): boolean {
    return (val === null || val === '' || (typeof val === 'number' && val < 0));
  }

  sanitize(val: any, units = '', isDate = false): any {
    if (this.isNullOrEmpty(val)) {
      return '—';
    }
    if (isDate) {
      return this.isNullOrEmpty(val) ? '-' : new DatePipe('en-CA').transform(val, 'MMM dd yyyy');
    }
    return '' + val + units;
  }

  getBoundingBox(): void {
    this.propertiesState$.pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe((state: PropertiesState) => {
      this.boundingBox = {
        xMin: state.boundingBox.xMin - 15,
        yMin: state.boundingBox.yMin - 15,
        xMax: state.boundingBox.xMax + 15,
        yMax: state.boundingBox.yMax + 15,
      };
    });
  }
}
